import * as userActions from '../actions/user';
import { normalizeOnRampAccountsPayload } from '../../utils/onRampHelpers';

const defaultState = {
  gettingUser: true,
  onRampAccounts: {},
  onRampDeposits: [],
};

// eslint-disable-next-line default-param-last
const user = (state = defaultState, action) => {
  switch (action.type) {
    case userActions.GET_USER: {
      const { getUserError, ...newState } = state;
      return {
        ...newState,
        gettingUser: true,
      };
    }
    case userActions.GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        gettingUser: false,
      };
    case userActions.GET_USER_ERROR:
      return {
        ...state,
        getUserError: action.payload,
        gettingUser: false,
      };
    case userActions.CLEAR_USER: {
      const { user, preferences, onRampAccounts, onRampDeposits, bankAccount, ...newState } = state;
      return newState;
    }
    case userActions.UPDATE_USER: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        updatingUser: true,
      };
    }
    case userActions.UPDATE_USER_SUCCESS:
      return {
        ...state,
        user: action.payload?.email ? { ...state.user, ...action.payload } : state.user,
        updatingUser: false,
      };
    case userActions.UPDATE_USER_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.UPDATE_USER_DETAILS: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        user: {
          ...state.user,
          userDetails: action.payload,
        },
        updatingUser: true,
      };
    }
    case userActions.UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          userDetails: action.payload,
        },
        updatingUser: false,
      };
    case userActions.UPDATE_USER_DETAILS_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.UPSERT_USER_ONBOARDING_PROFILE: {
      const { upsertUserOnboardingProfileError, ...newState } = state;
      return {
        ...newState,
        upsertingUserOnboardingProfile: true,
      };
    }
    case userActions.UPSERT_USER_ONBOARDING_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          userDetails: {
            ...state.user?.userDetails,
            onboardingProfile: action.payload,
          },
        },
        upsertingUserOnboardingProfile: false,
      };
    case userActions.UPSERT_USER_ONBOARDING_PROFILE_ERROR:
      return {
        ...state,
        upsertUserOnboardingProfileError: action.payload,
        upsertingUserOnboardingProfile: false,
      };
    case userActions.UPSERT_COMPANY_ONBOARDING_PROFILE: {
      const { upsertCompanyOnboardingProfileError, ...newState } = state;
      return {
        ...newState,
        upsertingCompanyOnboardingProfile: true,
      };
    }
    case userActions.UPSERT_COMPANY_ONBOARDING_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          company: {
            ...state.user?.company,
            onboardingProfile: action.payload,
          },
        },
        upsertingCompanyOnboardingProfile: false,
      };
    case userActions.UPSERT_COMPANY_ONBOARDING_PROFILE_ERROR:
      return {
        ...state,
        upsertCompanyOnboardingProfileError: action.payload,
        upsertingCompanyOnboardingProfile: false,
      };
    case userActions.UPDATE_USER_ADDRESS: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        updatingUser: true,
      };
    }
    case userActions.UPDATE_ALL_USER_DATA: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        updatingUser: true,
      };
    }
    case userActions.UPDATE_ALL_USER_DATA_SUCCESS:
      return {
        ...state,
        updatingUser: false,
      };
    case userActions.UPDATE_ALL_USER_DATA_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.UPDATE_COMPANY: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        updatingUser: true,
      };
    }
    case userActions.UPDATE_COMPANY_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          company: action.payload,
        },
        updatingUser: false,
      };
    case userActions.UPDATE_COMPANY_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.UPDATE_COMPANY_ADDRESS: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        user: {
          ...state.user,
          company: {
            ...state.user.company,
            address: action.payload,
          },
        },
        updatingUser: true,
      };
    }
    case userActions.UPDATE_COMPANY_ADDRESS_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          company: {
            ...state.user.company,
            address: action.payload,
          },
        },
        updatingUser: false,
      };
    case userActions.UPDATE_COMPANY_ADDRESS_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.UPDATE_ALL_COMPANY_DATA: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        updatingUser: true,
      };
    }
    case userActions.UPDATE_ALL_COMPANY_DATA_SUCCESS:
      return {
        ...state,
        updatingUser: false,
      };
    case userActions.UPDATE_ALL_COMPANY_DATA_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.GET_BANK_ACCOUNT: {
      const { getBankAccountError, bankAccount, ...newState } = state;
      return {
        ...newState,
        gettingBankAccount: true,
      };
    }
    case userActions.GET_BANK_ACCOUNT_SUCCESS: {
      const { onRampAccounts, primaryAccount } = normalizeOnRampAccountsPayload(action.payload);
      return {
        ...state,
        onRampAccounts,
        bankAccount: primaryAccount,
        gettingBankAccount: false,
      };
    }
    case userActions.GET_BANK_ACCOUNT_ERROR:
      return {
        ...state,
        getUserError: action.payload,
        getBankAccountError: action.payload,
        gettingBankAccount: false,
      };
    case userActions.GET_ON_RAMP_DEPOSITS: {
      const { getOnRampDepositsError, ...newState } = state;
      return {
        ...newState,
        onRampDeposits: [],
        gettingOnRampDeposits: true,
      };
    }
    case userActions.GET_ON_RAMP_DEPOSITS_SUCCESS:
      return {
        ...state,
        onRampDeposits: Array.isArray(action.payload) ? action.payload : [],
        gettingOnRampDeposits: false,
      };
    case userActions.GET_ON_RAMP_DEPOSITS_ERROR:
      return {
        ...state,
        getOnRampDepositsError: action.payload,
        gettingOnRampDeposits: false,
      };
    case userActions.UPDATE_BANK_ACCOUNT: {
      const { updateUserError, ...newState } = state;
      return {
        ...newState,
        updatingUser: true,
      };
    }
    case userActions.UPDATE_BANK_ACCOUNT_SUCCESS: {
      const updatedAccount = action.payload ?? state.bankAccount;
      const { onRampAccounts, primaryAccount } = normalizeOnRampAccountsPayload(updatedAccount);
      return {
        ...state,
        onRampAccounts: Object.keys(onRampAccounts).length > 0 ? onRampAccounts : state.onRampAccounts,
        bankAccount: primaryAccount ?? state.bankAccount,
        updatingUser: false,
      };
    }
    case userActions.UPDATE_BANK_ACCOUNT_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.SUBMIT_ONBOARDING: {
      const { submitOnboardingError, ...newState } = state;
      return {
        ...newState,
        submittingOnboarding: true,
      };
    }
    case userActions.TRACK_ONBOARDING: {
      const { onboardingRequestId, ...newState } = state;
      return {
        ...newState,
        ...action.payload,
      };
    }
    case userActions.SUBMIT_ONBOARDING_SUCCESS:
      return {
        ...state,
        onboardingSteps: action.payload,
      };
    case userActions.SUBMIT_ONBOARDING_ERROR:
      return {
        ...state,
        submitOnboardingError: action.payload,
        submittingOnboarding: false,
      };
    case userActions.GET_ONBOARDING_STATUS: {
      const { getOnboardingStatusError, ...newState } = state;
      return {
        ...newState,
        gettingOnboardingStatus: true,
      };
    }
    case userActions.GET_ONBOARDING_STATUS_SUCCESS:
      return {
        ...state,
        onboardingStatus: action.payload,
        gettingOnboardingStatus: false,
      };
    case userActions.GET_ONBOARDING_STATUS_ERROR:
      return {
        ...state,
        getOnboardingStatusError: action.payload,
        gettingOnboardingStatus: false,
      };
    case userActions.SET_ONBOARDING_PHONE_NUMBER: {
      const { setOnboardingPhoneNumberError, ...newState } = state;
      return {
        ...newState,
        settingOnboardingPhoneNumber: true,
      };
    }
    case userActions.SET_ONBOARDING_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        settingOnboardingPhoneNumber: false,
      };
    case userActions.SET_ONBOARDING_PHONE_NUMBER_ERROR:
      return {
        ...state,
        setOnboardingPhoneNumberError: action.payload,
        settingOnboardingPhoneNumber: false,
      };
    case userActions.SET_ONBOARDING_USER_TYPE: {
      const { setOnboardingUserTypeError, ...newState } = state;
      return {
        ...newState,
        settingOnboardingUserType: true,
      };
    }
    case userActions.SET_ONBOARDING_USER_TYPE_SUCCESS:
      return {
        ...state,
        settingOnboardingUserType: false,
      };
    case userActions.SET_ONBOARDING_USER_TYPE_ERROR:
      return {
        ...state,
        setOnboardingUserTypeError: action.payload,
        settingOnboardingUserType: false,
      };
    case userActions.GET_TERMS_CONDITIONS: {
      const { getTermsConditionsError, ...newState } = state;
      return {
        ...newState,
        getTermsConditionsLoading: true,
      };
    }
    case userActions.GET_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        termsConditions: action.payload,
        getTermsConditionsLoading: false,
      };
    case userActions.GET_TERMS_CONDITIONS_ERROR:
      return {
        ...state,
        getTermsConditionsError: action.payload,
        getTermsConditionsLoading: false,
      };
    case userActions.ACCEPT_TERMS_CONDITIONS: {
      const { acceptTermsConditionsError, ...newState } = state;
      return {
        ...newState,
        acceptingTermsConditions: true,
      };
    }
    case userActions.ACCEPT_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        acceptingTermsConditions: false,
      };
    case userActions.ACCEPT_TERMS_CONDITIONS_ERROR:
      return {
        ...state,
        acceptTermsConditionsError: action.payload,
        acceptingTermsConditions: false,
      };
    case userActions.UPDATE_USER_NAMES: {
      const { updateUserNamesError, ...newState } = state;
      return {
        ...newState,
        updatingUserNames: true,
      };
    }
    case userActions.UPDATE_USER_NAMES_SUCCESS:
      return {
        ...state,
        user: action.payload ?? state.user,
        updatingUserNames: false,
      };
    case userActions.UPDATE_USER_NAMES_ERROR:
      return {
        ...state,
        updateUserNamesError: action.payload,
        updatingUserNames: false,
      };
    case userActions.UPDATE_INDIVIDUAL_COLLECT_DATA:
      return {
        ...state,
        updatingIndividualCollectData: true,
        updateIndividualCollectDataError: undefined,
      };
    case userActions.UPDATE_INDIVIDUAL_COLLECT_DATA_SUCCESS:
      return {
        ...state,
        updatingIndividualCollectData: false,
      };
    case userActions.UPDATE_INDIVIDUAL_COLLECT_DATA_ERROR:
      return {
        ...state,
        updateIndividualCollectDataError: action.payload,
        updatingIndividualCollectData: false,
      };
    case userActions.ADVANCE_ONBOARDING_STEP:
      return {
        ...state,
        advancingOnboardingStep: true,
        advanceOnboardingStepError: undefined,
      };
    case userActions.ADVANCE_ONBOARDING_STEP_SUCCESS:
      return {
        ...state,
        advancingOnboardingStep: false,
      };
    case userActions.ADVANCE_ONBOARDING_STEP_ERROR:
      return {
        ...state,
        advanceOnboardingStepError: action.payload,
        advancingOnboardingStep: false,
      };
    case userActions.SAVE_COMPANY_COLLECT_DATA:
      return {
        ...state,
        updatingUser: true,
        updateUserError: undefined,
      };
    case userActions.SAVE_COMPANY_COLLECT_DATA_SUCCESS:
      return {
        ...state,
        updatingUser: false,
      };
    case userActions.SAVE_COMPANY_COLLECT_DATA_ERROR:
      return {
        ...state,
        updateUserError: action.payload,
        updatingUser: false,
      };
    case userActions.GET_KYC_STATUS:
      return {
        ...state,
        getKycStatusLoading: true,
        getKycStatusError: undefined,
      };
    case userActions.GET_KYC_STATUS_SUCCESS:
      return {
        ...state,
        kycStatus: action.payload,
        getKycStatusLoading: false,
      };
    case userActions.GET_KYC_STATUS_ERROR:
      return {
        ...state,
        getKycStatusError: action.payload,
        getKycStatusLoading: false,
      };
    case userActions.REQUEST_KYC:
      return {
        ...state,
        requestKycLoading: true,
        requestKycError: undefined,
      };
    case userActions.REQUEST_KYC_SUCCESS:
      return {
        ...state,
        requestKycLoading: false,
      };
    case userActions.REQUEST_KYC_ERROR:
      return {
        ...state,
        requestKycError: action.payload,
        requestKycLoading: false,
      };
    case userActions.GET_USER_PREFERENCES: {
      const { getUserPreferencesError, ...newState } = state;
      return {
        ...newState,
        gettingUserPreferences: true,
      };
    }
    case userActions.GET_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.payload,
        gettingUserPreferences: false,
      };
    case userActions.GET_USER_PREFERENCES_ERROR:
      return {
        ...state,
        getUserPreferencesError: action.payload,
        gettingUserPreferences: false,
      };
    case userActions.UPSERT_USER_PREFERENCES: {
      const { upsertUserPreferencesError, ...newState } = state;
      return {
        ...newState,
        upsertingUserPreferences: true,
      };
    }
    case userActions.UPSERT_USER_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: action.payload,
        upsertingUserPreferences: false,
      };
    case userActions.UPSERT_USER_PREFERENCES_ERROR:
      return {
        ...state,
        upsertUserPreferencesError: action.payload,
        upsertingUserPreferences: false,
      };
    default:
      return state;
  }
};

export default user;
